import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { DialogPropertyComponent } from '@shared/components/dialog/template/dialog-json-buider/dialog-property/dialog-property.component';
import { JsonBuilderService } from '../../json-builder.service';

interface Breadcrumb {
  root?: string
  whereThis?: Array<any>
}

@Component({
  selector: 'json-template-property',
  templateUrl: './template-property.component.html',
  styleUrls: ['./template-property.component.scss']
})
export class TemplatePropertyComponent {
  @Input() data;
  @Input() index;
  @Input() name;
  @Input() breadcrumb: Breadcrumb;
  @Output() deleteEvent = new EventEmitter<any>();

  public property;
  private readonly allFields = this.jsonBuilderService.getOptions();

  constructor(
    private dialog: MatDialog,
    private jsonBuilderService: JsonBuilderService
  ) { }

  ngOnInit() {
    this.setProperty();
  }

  private setProperty() {
    this.property = {
      root: this.data,
      name: this.name,
      index: this.index,
      value: this.data[this.index]
    }
  }

  onDelete() {
    this.deleteEvent.emit({ index: this.property.index })
  }

  public openDialog() {
    this.dialog.open(DialogComponent, {
      width: '1080px',
      minHeight: '600px',
      disableClose: true,
      data: {
        titleDialog: 'Valor',
        titleButton: 'Salvar',
        component: DialogPropertyComponent,
        contentDialogClassName: 'dialog-content',
        data: this.property,
        breadcrumb: JSON.parse(JSON.stringify(this.breadcrumb))
      },
      autoFocus: false
    }).afterClosed().subscribe(() => {
      this.setProperty();
    });
  }

  public getFieldNameOfVariable(variable_key: string): string {
    const field = this.allFields.find(field => field.variable_key === variable_key);
    return field ? field.label : variable_key;
  }
}
